import React from "react";
import { Box, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import { useEducationDashboardSummary } from "../../hooks/api/education/usePlatform";

const EducationDashboardCards: React.FC = () => {
  const { t } = useKivunovaTranslation();
  const { data } = useEducationDashboardSummary();

  if (!data) return null;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        gap: 2,
        mb: 3
      }}
    >
      <Box
        sx={{
          p: 2,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2
        }}
        data-testid="dashboard-overdue-card"
      >
        <Typography variant="body2" color="text.secondary">
          {t("overdue-invoices", "Overdue invoices")}
        </Typography>
        <Typography variant="h6">{data.overdueInvoiceCount ?? 0}</Typography>
      </Box>
      <Box
        sx={{
          p: 2,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2
        }}
        data-testid="dashboard-pending-expenses-card"
      >
        <Typography variant="body2" color="text.secondary">
          {t("pending-expenses", "Pending expenses")}
        </Typography>
        <Typography variant="h6">{data.pendingExpenseTotal ?? 0}</Typography>
      </Box>
      <Box
        sx={{
          p: 2,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2
        }}
        data-testid="dashboard-fee-collected-card"
      >
        <Typography variant="body2" color="text.secondary">
          {t("fee-collected", "Fee collected")}
        </Typography>
        <Typography variant="h6">{data.feeCollectedTotal ?? 0}</Typography>
      </Box>
      <Box
        sx={{
          p: 2,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2
        }}
        data-testid="dashboard-fee-outstanding-card"
      >
        <Typography variant="body2" color="text.secondary">
          {t("fee-outstanding", "Fee outstanding")}
        </Typography>
        <Typography variant="h6">{data.feeOutstandingTotal ?? 0}</Typography>
      </Box>
      <Box
        sx={{
          p: 2,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2
        }}
        data-testid="dashboard-low-stock-card"
      >
        <Typography variant="body2" color="text.secondary">
          {t("low-stock-items", "Low stock items")}
        </Typography>
        <Typography variant="h6">{data.lowStockCount ?? 0}</Typography>
      </Box>
    </Box>
  );
};

export default EducationDashboardCards;
